export default "__VITE_ASSET__BBYLNnll__"